export const numberFormat = new Intl.NumberFormat().format;
export const deltaFormat = new Intl.NumberFormat(undefined, { signDisplay: "exceptZero" }).format;

export function RankCell({ rank, prevRank }) {
    const delta = rank > 0 && prevRank > 0 ? prevRank - rank : 0;
    const color = delta > 0 ? "green" : delta < 0 ? "red" : "inherit";
    return (
        <td style={{ textAlign: "right", lineHeight: "2rem" }}>
            <div
                style={{ display: "flex", alignItems: "center", marginLeft: "1em", gap: "0.25em" }}
            >
                <b style={{ flex: 1 }}>{rank > 0 ? numberFormat(rank) : "-"}</b>
                <span style={{ flexBasis: "3em", fontSize: "0.75em", color }}>
                    {delta ? deltaFormat(delta) : null}
                </span>
            </div>
        </td>
    );
}
